import { Event } from '@sentry/types';

export const isHeadlessChrome = (event: Event) => {
    const headers = event.request?.headers;
    const userAgent = headers && headers['User-Agent'] || '';

    return userAgent.includes('HeadlessChrome');
};
